formatMoney = (cents, format) => {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.PXUTheme.moneyFormat || "${{amount}}");

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class SellingPlanRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onSellingPlanChange);

    this.variant = document.querySelector('variant-selects') || document.querySelector('variant-radios');
    const dataEl = this.querySelector('[data-component-data]');
    if (dataEl) {
      const data = dataEl.getAttribute('data-component-data') || dataEl.innerHTML;
      this.data = data ? JSON.parse(data) : null;
    }
    this.selectedPlanId = null;
    this.price = null;
    this.compare_at_price = null;
    this.onSellingPlanChange();
  }

  onSellingPlanChange() {
    //const purchasedOption = this.querySelector('input[name="purchasedOption"]:checked').value;
    this.selectedPlanId = this.querySelector('select[name="selling_plan"]') ? this.querySelector('select[name="selling_plan"]').value : null;
    const oneTimeEl = this.querySelector('.rc-radio.onetime-radio');
    const snsEl = this.querySelector('.rc-radio.subscription-radio');
    const cardPrice = this.closest('[data-component="product-card"]').querySelector('.product-card__price .price__regular .price__regular-value');
    const cardPriceCompare = this.closest('[data-component="product-card"]').querySelector('.product-card__price .price__sale .price__sale-compare');
    const priceContainer = this.closest('[data-component="product-card"]').querySelector('.product-card__price .price');
    const variantSelector = this.querySelector('select[name="id"]') || this.querySelector('input[name="id"]');
    const variantID = variantSelector ? variantSelector?.value : null;
    const variantData = (this.data || []).find((item) => {
      return item?.id == variantID;
    });
    this.availableSellingPlans = (variantData?.selling_plan_allocations || [])?.map((v) => `${v.selling_plan_id}`);

    if (!this.availableSellingPlans.length) {
      this.querySelector('.rc-selling-plans .select-dropdown__list').classList.add('hidden');
      if (this.querySelector('select[name="selling_plan"]')) {
        this.querySelector('select[name="selling_plan"]').value = '';
      }
    } else {
      this.querySelector('.rc-selling-plans .select-dropdown__list').classList.remove('hidden');
      const options = this.querySelectorAll('.rc-selling-plans .select-dropdown__list .select-dropdown__list-item');
      options.forEach((option) => {
        if (option.dataset.value === '' || this.availableSellingPlans.indexOf(option.dataset.value) !== -1) {
          option.classList.remove('hidden');
        } else {
          option.classList.add('hidden');
        }
        if (variantData?.requires_selling_plan && option.dataset.value === '') {
          option.classList.add('hidden');
        }
        if (this.selectedPlanId === option.dataset.value && option.classList.contains('hidden')) {
          this.querySelector('.rc-selling-plans .select-dropdown__list .select-dropdown__list-item:not(.hidden)').click();
        }
      });
    }

    if (this.selectedPlanId) {
      if (oneTimeEl) {
        oneTimeEl.classList.remove('rc-radio--active');
      }
      if (snsEl) {
        snsEl.classList.add('rc-radio--active');
      }
      this.price = (variantData?.selling_plan_allocations || []).find((plan) => {
        return plan?.selling_plan_id == this.selectedPlanId;
      })?.price;
      this.compare_at_price = variantData?.price || null;
    } else {
      if (oneTimeEl) {
        oneTimeEl.classList.add('rc-radio--active');
      }
      if (snsEl) {
        snsEl.classList.remove('rc-radio--active');
      }
      this.price = variantData?.price || null;
      this.compare_at_price = variantData?.compare_at_price || null;
    }
    if (this.price && cardPrice) {
      cardPrice.innerHTML = formatMoney(this.price);
      if (this.closest('[data-component="product-card"]').querySelector('.product-card__price .price__sale .price__sale-value')) {
        this.closest('[data-component="product-card"]').querySelector('.product-card__price .price__sale .price__sale-value').innerHTML = formatMoney(this.price);
      }
    }
    if (this.compare_at_price && cardPriceCompare) {
      cardPriceCompare.innerHTML = formatMoney(this.compare_at_price);
    }
    if (this.price != this.compare_at_price && this.compare_at_price && priceContainer) {
      priceContainer.classList.add('price--on-sale');
    } else {
      priceContainer.classList.remove('price--on-sale');
    }
  }
}

customElements.define('sellingplan-radios', SellingPlanRadios);

document.addEventListener('DOMContentLoaded', () => {
  initLazyBg();
  createSelect();
}, false);

function createSelect() {
    var select = document.querySelectorAll('select.select-dropdown'),
      liElement,
      ulElement,
      optionValue,
      iElement,
      optionText,
      selectDropdown,
      elementParentSpan;

    for (var select_i = 0, len = select.length; select_i < len; select_i++) {
      if (!select[select_i].parentElement.classList.contains('select-dropdown')) {
        select[select_i].style.display = 'none';
        const selectedIndex = select[select_i].selectedIndex
        wrapElement(document.getElementById(select[select_i].id), document.createElement('div'), select_i, (select[select_i].options[selectedIndex].innerText || select[select_i].getAttribute('placeholder-text')));

        for (var i = 0; i < select[select_i].options.length; i++) {
          liElement = document.createElement("li");
          optionValue = select[select_i].options[i].value;
          optionText = document.createTextNode(select[select_i].options[i].text);
          liElement.className = 'select-dropdown__list-item';
          liElement.setAttribute('data-value', optionValue);
          liElement.appendChild(optionText);
          ulElement.appendChild(liElement);
          if (select[select_i].options[i].hasAttribute('hidden') && optionValue !== '') {
            liElement.classList.add('hidden');
          } else {
            liElement.classList.remove('hidden');
          }

          liElement.addEventListener('click', function () {
            displyUl(this);
          }, false);
        }
      }
    }
    function wrapElement(el, wrapper, i, placeholder) {
      if (!el) return;
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);

      document.addEventListener('click', function (e) {
        let clickInside = wrapper.contains(e.target);
        if (!clickInside) {
          let menu = wrapper.getElementsByClassName('select-dropdown__list');
          menu[0].classList.remove('active');
        }
      });

      var buttonElement = document.createElement("button"),
        spanElement = document.createElement("span"),
        spanText = document.createTextNode(placeholder);
        ulElement = document.createElement("ul");

      wrapper.className = 'select-dropdown select-dropdown--' + i;
      buttonElement.className = 'select-dropdown__button select-dropdown__button--' + i;
      buttonElement.setAttribute('data-value', '');
      buttonElement.setAttribute('type', 'button');
      spanElement.className = 'select-dropdown select-dropdown--' + i;
      ulElement.className = 'select-dropdown__list select-dropdown__list--' + i;
      ulElement.id = 'select-dropdown__list-' + i;

      wrapper.appendChild(buttonElement);
      spanElement.appendChild(spanText);
      buttonElement.appendChild(spanElement);
      wrapper.appendChild(ulElement);
    }

    function displyUl(element) {

      if (element.tagName == 'BUTTON') {
        selectDropdown = element.parentNode.getElementsByTagName('ul');
        //var labelWrapper = document.getElementsByClassName('js-label-wrapper');
        for (var i = 0, len = selectDropdown.length; i < len; i++) {
          selectDropdown[i].classList.toggle("active");
          //var parentNode = $(selectDropdown[i]).closest('.js-label-wrapper');
          //parentNode[0].classList.toggle("active");
        }
      } else if (element.tagName == 'LI') {
        var selectId = element.parentNode.parentNode.getElementsByTagName('select')[0];
        selectElement(selectId.id, element.getAttribute('data-value'));
        elementParentSpan = element.parentNode.parentNode.getElementsByTagName('span');
        element.parentNode.classList.toggle("active");
        elementParentSpan[0].textContent = element.textContent;
        elementParentSpan[0].parentNode.setAttribute('data-value', element.getAttribute('data-value'));
        if (selectId.closest('sellingplan-radios')) {
          selectId.closest('sellingplan-radios').dispatchEvent(new Event('change'));
        }
      }

    }
    function selectElement(id, valueToSelect) {
      var element = document.getElementById(id);
      element.value = valueToSelect;
      element.setAttribute('selected', 'selected');
    }
    var buttonSelect = document.getElementsByClassName('select-dropdown__button');
    for (var i = 0, len = buttonSelect.length; i < len; i++) {
      buttonSelect[i].addEventListener('click', function (e) {
        e.preventDefault();
        displyUl(this);
      }, false);
    }
}

function initLazyBg() {
  // all elements wioth background images that should be lazy loaded 
  const lazyImages = document.querySelectorAll('.lazybg');
 
  // options for the observer
  const backgroundOptions = {
     threshold: 0,
     rootMargin: "0px 0px 100px 0px"
  };

  // the observer
  const imageObserver = new IntersectionObserver((entries, imageObserver) => {
     entries.forEach(entry => {
         if (entry.isIntersecting) {
             showImageBackground(entry.target);
             imageObserver.unobserve(entry.target);
         }
     });
  }, backgroundOptions);

    
  // observe each image
  lazyImages.forEach(image => {
     imageObserver.observe(image);
  });

  // show background image
  function showImageBackground(node) {
     node.classList.remove('lazybg');
  }
}